import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    container: {
      border: '1px solid #E0E0E0',
      borderRadius: 5,
      padding: 15,
    },
    title: {
      color: theme?.palette?.primary?.main,
      marginBottom: 12,
    },
    items: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '10px 0',
    },
    numberInput: {
      minWidth: 110,
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
    },
    input: {
      width: 35,
      height: 30,
      textAlign: 'center',
      borderLeft: 0,
      borderRight: 0,
      borderTop: '1px solid #E0E0E0',
      borderBottom: '1px solid #E0E0E0',
      background: 'transparent',
    },
    btnMinus: {
      width: 35,
      minWidth: 35,
      borderRadius: '5px 0 0 5px',
      height: 30,
      border: '1px solid #E0E0E0',
    },
    btnPlus: {
      width: 35,
      minWidth: 35,
      borderRadius: '0 5px 5px 0',
      height: 30,
      border: '1px solid #E0E0E0',
    },
    label: {
      paddingRight: 10,
    },
    price: {
      paddingRight: 10,
      textAlign: 'right',
    },
  };
});

export default useStyles;
